/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S8_HeadingInputs */

const tr_iade_iptal_s8_heading = /** @type {(inputs: Iade_Iptal_S8_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Sağlayıcı'nın Fesih Hakkı`)
};

const en_iade_iptal_s8_heading = /** @type {(inputs: Iade_Iptal_S8_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. The Provider's Right of Termination`)
};

const de_iade_iptal_s8_heading = /** @type {(inputs: Iade_Iptal_S8_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Beendigungsrecht des Anbieters`)
};

const ru_iade_iptal_s8_heading = /** @type {(inputs: Iade_Iptal_S8_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Право Поставщика на расторжение`)
};

/**
* | output |
* | --- |
* | "8. The Provider's Right of Termination" |
*
* @param {Iade_Iptal_S8_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s8_heading = /** @type {((inputs?: Iade_Iptal_S8_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S8_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s8_heading(inputs)
	if (locale === "de") return de_iade_iptal_s8_heading(inputs)
	if (locale === "ru") return ru_iade_iptal_s8_heading(inputs)
	return tr_iade_iptal_s8_heading(inputs)
});